import LineChartViz from '../vizs/LineChartViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * A line chart or line plot or line graph or curve chart is a type of chart which displays information as a series of data points called 'markers' connected by straight line segments.
 * 
 * ### Example Usage
 * ```javascript
 *   
 *   import {LineChart} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new LineChart($el, data, config);
 *   
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 2 or more columns. 
 * 
 * Each row represents a point in the X axis. The first column should be the id/label of each point. The rest of the columns should represent the values for each of the lines in the chart.
 * 
 * |  xValue    | line1  |  line2   |  line3   |
 * | --------   | ------ |  ------  |  ------  |
 * |   0       |    22.4|      15.4|      43.2|
 * |   1      |    52.3|      29.3|      12.8|
 * |   2      |    12.8|      34.1|      61.4|
 * |   3      |    26.0|      12.3|      14.5|
 * 
 * {.data-table}
 * 
 * */
export default class LineChartComponent extends BaseComponent {
  static vizClass = LineChartViz
  static dataFormat = [
    {index:0, axis:'x0', label:'id', types:[Number,String,Date],role:'id',roleLabel:'X value - Number, Date (dd-mm-yyyy) or String'},
    {index:-1, axis:'y0', label:'Line', types:[Number,null],role:'value',roleLabel: 'Y value'}
  ]
  static componentLabel = "Line chart"
  static defaultConfig = {
    title: this.componentLabel,
    ItemsHelper:{
      colorMode: 'stroke'
    }
  }
}
